/* ══════════════════════════════════════════════════════════════════════════
 * THE SHOW-PASSWORD EYE
 *
 * ⚠️ IT WAS WRITTEN OUT IN FULL INSIDE SignIn.jsx WHEN SIGN-IN WAS THE ONLY
 * SCREEN WITH A PASSWORD FIELD. Joining has two, the reset screen has two, and
 * Settings will have more. Six copies of forty lines of SVG is six places for
 * the crossed-out eye to stop matching the open one, and nobody would report
 * it — each screen looks fine on its own. That is the fault behind /v1, the
 * sixteen connector files and the two cuisine lists, every time.
 *
 * ⚠️ THE ICON IS THE STATE, NOT THE WISH. Al, 17 September 2026: *"shouldn't
 * the eye be open when you're seeing the password and have a cross across it
 * when it's closed and just the dots show."* It shows what is happening NOW.
 *
 * ⚠️ AND COLOUR ALONE FAILED IN HIS HAND. `:hover` latches on a touchscreen,
 * so the eye stayed persimmon whether the password was showing or not — *"it
 * is an orange. and stays in orange."* An icon works with a stuck hover, in
 * sunlight, and for somebody who cannot tell persimmon from cream.
 *
 * ⚠️ THE LABEL SAYS WHAT PRESSING IT WILL DO and changes when the state does.
 * A button stuck on "Show password" while the password is showing tells a
 * screen reader the opposite of the truth.
 *
 * ⚠️ THIS IS STILL THE SECOND OF THE TWO PATHS IN `eleat_password.js`, which
 * React cannot call because that one writes innerHTML. They change together,
 * and the prototype is the one being ported FROM, never the other way round.
 * ══════════════════════════════════════════════════════════════════════════ */

export function Eye({ on, onToggle }) {
  return (
    <button
      className={on ? 'eye on' : 'eye'}
      type="button"
      aria-label={on ? 'Hide password' : 'Show password'}
      aria-pressed={on}
      onClick={onToggle}
    >
      {on ? (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
             strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7z" />
          <circle cx="12" cy="12" r="3" />
        </svg>
      ) : (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
             strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" />
          <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
          <path d="M14.12 14.12a3 3 0 1 1-4.24-4.24" />
          <line x1="1" y1="1" x2="23" y2="23" />
        </svg>
      )}
    </button>
  );
}
